import { render } from "./PlanCard.vue?vue&type=template&id=2c9ea78c&scoped=true&ts=true"
import script from "./PlanCard.vue?vue&type=script&lang=ts"
export * from "./PlanCard.vue?vue&type=script&lang=ts"

import "./PlanCard.vue?vue&type=style&index=0&id=2c9ea78c&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9ea78c"]])

export default __exports__